// pages/UsersPage.js
import React from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

const UsersPage = () => {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div style={{ marginLeft: '240px', width: '100%' }}>
        <Navbar />
        <div style={{ padding: '20px' }}>
          <h2>Users</h2>
          <p>Manage users here.</p>
        </div>
      </div>
    </div>
  );
};

export default UsersPage;
